
import { DappLocalState } from '@/types'
import { defineComponent, PropType } from 'vue'
import {microalgosToAlgos} from 'algosdk'


export default defineComponent({
    props: {
        localState: {
            type: Object as PropType<DappLocalState>,
            required: true,
        },
        color: {
            type: String,
            default: 'black'
        }
    },
    computed: {
        localStateBetAlgos(): number {
            return microalgosToAlgos((this.localState as DappLocalState).Bet)
        },
        hasClaimed(): boolean {
            return this.localState.Bet === 0
        }
    }
})
